import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  static targets = ["container"]
  add() {
    const template = this.containerTarget
      .querySelector(".vat-item-row")
      .cloneNode(true)

    // Werte leeren
    template.querySelectorAll("input").forEach(input => {
      input.value = ""
    })
    this.containerTarget.appendChild(template)
  }

  remove(event) {

    const row = event.target.closest(".vat-item-row")
    const destroyInput = row.querySelector("input[name*='_destroy']")

    if (destroyInput) {
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
  }

}
